<template>
  <a-modal title="订单详情" :width="900" :visible="visible" :confirmLoading="confirmLoading" :footer="false"
    @cancel="handleCancel" v-if="hackReset">
    <div class="viewDetial-tiem">
      <div class="viewDetial-title">患者信息</div>
      <a-row style="height:30px">
        <a-col :span="12">
          <label style="padding-left:28px">姓名：{{ this.userDate.patientname + ' / ' + (this.userDate.sex == '1' ? '男' : this.userDate.sex == '2' ? '女' : '') + ' / ' + this.userDate.age  }}</label>
        </a-col>
        <a-col :span="12">
          <label>身份证号：{{ this.userDate.cardno == '' || this.userDate.cardno == null || this.userDate.cardno ==undefined ? '' : this.userDate.cardno.replace(/^(\d{2})\d+(\d{2})$/, "$1************$2") }}</label>
        </a-col>
      </a-row>
      <a-row style="height:30px">
        <a-col :span="12">
          <label style="padding-left:15px">手机号：{{ this.userDate.mobile }}</label>
        </a-col>
        <a-col :span="12">
          <label style="padding-left:28px">地址：{{ this.userDate.address }}</label>
        </a-col>
      </a-row>
      <a-row style="padding-top: 10px; padding-bottom: 10px; line-height: 23px;">
        <a-col>
          <label style="padding-left:15px">病情描述：{{ this.userDate.diseaseDesc }}</label>
        </a-col>
      </a-row>
      <a-row style="padding-top: 10px; padding-bottom: 10px;">
        <a-col :span="24">
          <label style="padding-left:15px" v-if="srcList.length>0">图片证明:
            <img v-for="(item,index) in srcList" :key="index" :src="item" class="srcListSize" @click="handlePreviewImg(item)"/>
          </label>
          <label style="padding-left:15px" v-else>图片证明: <span style="padding-left:10px"> ---</span>
          </label>
        </a-col>
      </a-row>
    </div>
    <div class="viewDetial-tiem">
      <div class="viewDetial-title">预约信息</div>
      <a-row style="height:30px">
        <a-col :span="12">
          <label style="padding-left:28px">科室：{{ this.userDate.deptName }}</label>
        </a-col>
        <a-col :span="12">
          <label>预计评估：{{ this.userDate.planTime }}</label>
        </a-col>
      </a-row>
      <a-row style="height:30px">
        <a-col :span="12">
          <label>护理项目：{{ this.userDate.itemName }}</label>
        </a-col>
        <a-col :span="12">
          <label>提交时间：{{ this.userDate.updateTime }}</label>
        </a-col>
      </a-row>
      <a-row style="height:30px" v-if="status == 1">
        <a-col :span="12">
          <label></label>
        </a-col>
        <a-col :span="12">
          <label>处理时间：{{ this.userDate.assessmentTime }}</label>
        </a-col>
      </a-row>
    </div>


              
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancelImg">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>


  </a-modal>
</template>

<script>
  import { assessDetial } from '@/api/modular/interhospital/assessQuery/assessQueryMange'
  export default {
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 15 }
        },
        ctstampDateString: '',
        birthdayDateString: '',
        visible: false,
        confirmLoading: false,
        form: this.$form.createForm(this),
        parameter : {},
        userDate : '',
        hackReset: true,
        status : '',
        srcList:[],
        previewImage: '',
        previewVisible: false,
        
      }
    },
    methods: {
      // 初始化方法
      add (record) {
        this.parameter.id = record.id;
        this.status = record.status
        this.visible = true;
        assessDetial(this.parameter).then(res=>{
          // console.log('res.data==='+ res.data.)
          this.userDate = res.data;
          this.srcList = []
          this.userDate.image.split(',').map((item)=>{
            this.srcList.push('https://interhospital.youjiankang.net/' +item) 
          })
          console.log('详情接口========',srcList)
        });
      },
      // 放大查看
      handlePreviewImg(file) {
        this.previewImage = file
        this.previewVisible = true
      },
      // 取消放大
      handleCancelImg() {
        this.previewVisible = false
      },
      onChangectstamp(date, dateString) {
        this.ctstampDateString = dateString
      },
      onChangebirthday(date, dateString) {
        this.birthdayDateString = dateString
      },
      handleCancel () {
        this.visible = false;
        this.hackReset = false;
        this.$nextTick(()=>{
          this.hackReset = true;
        })
      }
    }
  }
</script>
<style lang="less" scoped>
.srcListSize{
  width:80px;
  height:90px;
  margin-right: 13px;
}
.viewDetial-tiem{
  margin-bottom: 10px;
}
.viewDetial-title{
  height: 40px;
  line-height: 40px;
  font-family: "PingFang SC ", "PingFang SC", sans-serif;
  font-weight: 650;
  font-style: normal;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.847);
  margin-bottom: 20px;
  .viewDetial-title-notes{
    font-weight: 400;
    font-size: 13px;
    color: rgba(127, 127, 127, 0.847058823529412);
    margin-left: 15px;
  }
}
</style>
